/*!
 *
 *  load-images.ts
 *
 */
var load = function (image) {
    return new Promise(function (resolve, reject) {
        if (image.complete) {
            resolve(image);
        }
        else {
            image.addEventListener('load', function () {
                resolve(image);
            });
            image.addEventListener('error', function (err) {
                reject(err);
            });
        }
        ;
    });
};
export default function loadImages(selector) {
    var images = Array.from(document.querySelectorAll(selector));
    var loadPromises = images.map(function (image) { return load(image); });
    return Promise.all(loadPromises);
}
